import { Request, Response } from 'kts-scaffold-framework/server';
import { CallType } from 'kts-scaffold-framework/utils/ajax';
import { Urls } from 'kts-platform-frame/entry/constant';
import ApiBasic from 'kts-platform-frame/api/ApiBasic';
import { MyStore, reducers } from 'kts-platform-frame/redux';
import service from 'kts-platform-frame/service';
import IData from './IData';
import IOptions from './IOptions';

/**
 * Login
 * 用户登录
 */
class Login extends ApiBasic<IOptions, IData> {

    /** 入口 */
    public async api(option: IOptions): Promise<Response<IData>> {

        option.identifier = option.identifier.replace(/^\s+|\s+$/g, "");

        // const req: Request = new Request(CallType.POST, Urls.WEB_TOKEN_LOGIN, option);
        const { user } = MyStore.instance.getState();

        let data = await service.post(Urls.WEB_TOKEN_LOGIN, option).end(window);
        
        if (data.err) {
            return new Response(data.err, null);
        }
        
        user.account = option.identifier;
        user.cToken = data.res.token;

        MyStore.instance.dispatch(reducers.user.ActionTypes.fnSetUserInfo, user);

        return new Response(null);
    }
}

export default new Login().run;



// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/api/webToken/login/index.ts